// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {
    background-color: #2D3055;
    padding: 30px 0px;
    width: 100%;
    border-radius: 8px;
}

.MuiDialog-root.youtubeContainerPublish .MuiDialog-container .MuiPaper-root {
    background-color: #2D3055;
    padding: 30px 0px;
    width: 100%;
    border-radius: 8px;
}

.MuiBox-root.youTubeheader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px;
}

.MuiBox-root.headerContent {
    display: flex;
    align-items: center;
    gap: 10px;
}

.MuiTypography-root.youtubeText {
    font-size: 20px;
    font-weight: 400;
    color: #E4E5ED;
    font-family: var(--font-family-primary);
}

.MuiButtonBase-root.copyLinkButton {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #3B3E68;
    color: #E4E5ED;
    padding: 8px 16px;
    border-radius: 10px;
    text-transform: none;
}

.MuiTypography-root.copyText {
    font-size: 14px;
    font-weight: 400;
    color: #E4E5ED;
    font-family: var(--font-family-primary);
}

.MuiDivider-root.ytubeDivider {
    border: 1.05px solid #FFFFFF26;
    margin-top: 15px;
}

.MuiBox-root.youtubeContent {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.MuiBox-root.youtubeConnector {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-direction: column;
}

.MuiTypography-root.youtubeDescription {
    font-size: 14px;
    font-weight: 400;
    color: #E4E5ED;
    font-family: var(--font-family-primary);
}

.MuiBox-root.youtubePublish {
    display: block;
    gap: 10px;
    margin: 25px 0px 0px 0px;
}

.videoPreview {
    width: 100%;
    object-fit: cover;
    height: 350px;
}

.MuiBox-root.buttonEnd {
    display: flex;
    justify-content: center;
}

.MuiBox-root.publishedContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    justify-content: center;
    height: 100%;
}

.youtubeConnect {
    border: 2px solid #EFEAEA;
    border-radius: 20px;
}

.youtube {
    opacity: 0.5;
}

.disabledIcon {
    cursor: not-allowed;
    opacity: 0.5;
}

.MuiBox-root.youtubeLink {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    justify-content: space-around;
}

.MuiTypography-root.channelName {
    font-size: 20px;
    font-weight: 400;
    color: #fff;
    font-family: var(--font-family-primary);
}

.MuiBox-root.channelBox {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    justify-content: space-between;
    margin-bottom: 20px;
}

.youtubeHeaderIcon {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}

.IconHeader {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.MuiBox-root.toggleContainer {
    display: flex;
    align-items: center;
    gap: 10px;
}

.MuiBox-root.width44 {
    width: 100%;
}

.MuiBox-root.youtubeCategory {
    display: flex;
    gap: 10px;
    align-items: center;
}

.MuiFormLabel-asterisk {
    color: #FF0000;
}

.MuiAutocomplete-endAdornment {
    display: none;
}

.MuiBox-root.buttonEnds {
    display: flex;
    gap: 10px;
}
/* tabs section */
.MuiBox-root.ytubeTabSection{
    margin-bottom: 20px;
}
.MuiTabs-root.ytubeTabs .MuiTabs-scroller .MuiTabs-flexContainer {
    border-bottom: 1px solid #4F5384;
}
.MuiButtonBase-root.ytubeTab{
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
    color: #B3B0C1;
    font-family: var(--font-family-primary);
    min-width: auto;
    padding: 0px;
    margin-right: 20px;
}
.MuiButtonBase-root.ytubeTab.Mui-selected{
    color: #fff;
    border-bottom: 2px solid #fff;
}
.MuiTabs-indicator{
    background: #fff !important;
}
.MuiFormLabel-root.formlabel{
font-family: var(--font-family-primary);
color: #fff;
font-size: 16px;
font-weight: 400;
}

@media screen and (min-width: 768px) {
    .MuiBox-root.youtubePublish {
        display: flex;
        align-items: flex-start;
        gap: 10px;
    }

    .MuiBox-root.videoConntector {
        display: flex;
        align-items: flex-start;
        gap: 20px;
        flex-direction: column;
    }

    .MuiBox-root.buttonEnd {
        display: flex;
        justify-content: flex-end;
        padding: 0px 20px;
    }

    .MuiBox-root.buttonEnds {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }

    .MuiBox-root.width44 {
        width: 44%;
    }

    .MuiBox-root.youtubeConnector {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-direction: row;
        justify-content: space-between;
    }
}

@media screen and (min-width: 1024px) {
    .MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {
        max-width: 80%;
    }

}

@media screen and (min-width: 1440px) {
    .MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {
        max-width: 60%;
    }

}

@media screen and (min-width: 1920px) {
    .MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {
        max-width: 50%;
    }

}


/* date picker */

.MuiBox-root.dateCategory{
    display: flex;
    gap: 10px;
    flex-direction: column;
}
.MuiFormLabel-root{
    color: #fff
}
.MuiButtonBase-root.MuiPickersDay-root{
background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/Popup/YouTubePopup/youtubePopup.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;AACA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,2BAA2B;AAC/B;AACA;AACA,uCAAuC;AACvC,WAAW;AACX,eAAe;AACf,gBAAgB;AAChB;;AAEA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,mBAAmB;QACnB,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,cAAc;IAClB;;AAEJ;;AAEA;IACI;QACI,cAAc;IAClB;;AAEJ;;;AAGA,gBAAgB;;AAEhB;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI;AACJ;AACA;AACA,6BAA6B;AAC7B","sourcesContent":[".MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {\n    background-color: #2D3055;\n    padding: 30px 0px;\n    width: 100%;\n    border-radius: 8px;\n}\n\n.MuiDialog-root.youtubeContainerPublish .MuiDialog-container .MuiPaper-root {\n    background-color: #2D3055;\n    padding: 30px 0px;\n    width: 100%;\n    border-radius: 8px;\n}\n\n.MuiBox-root.youTubeheader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px 20px;\n}\n\n.MuiBox-root.headerContent {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.MuiTypography-root.youtubeText {\n    font-size: 20px;\n    font-weight: 400;\n    color: #E4E5ED;\n    font-family: var(--font-family-primary);\n}\n\n.MuiButtonBase-root.copyLinkButton {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: #3B3E68;\n    color: #E4E5ED;\n    padding: 8px 16px;\n    border-radius: 10px;\n    text-transform: none;\n}\n\n.MuiTypography-root.copyText {\n    font-size: 14px;\n    font-weight: 400;\n    color: #E4E5ED;\n    font-family: var(--font-family-primary);\n}\n\n.MuiDivider-root.ytubeDivider {\n    border: 1.05px solid #FFFFFF26;\n    margin-top: 15px;\n}\n\n.MuiBox-root.youtubeContent {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.MuiBox-root.youtubeConnector {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-direction: column;\n}\n\n.MuiTypography-root.youtubeDescription {\n    font-size: 14px;\n    font-weight: 400;\n    color: #E4E5ED;\n    font-family: var(--font-family-primary);\n}\n\n.MuiBox-root.youtubePublish {\n    display: block;\n    gap: 10px;\n    margin: 25px 0px 0px 0px;\n}\n\n.videoPreview {\n    width: 100%;\n    object-fit: cover;\n    height: 350px;\n}\n\n.MuiBox-root.buttonEnd {\n    display: flex;\n    justify-content: center;\n}\n\n.MuiBox-root.publishedContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    justify-content: center;\n    height: 100%;\n}\n\n.youtubeConnect {\n    border: 2px solid #EFEAEA;\n    border-radius: 20px;\n}\n\n.youtube {\n    opacity: 0.5;\n}\n\n.disabledIcon {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n.MuiBox-root.youtubeLink {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    justify-content: space-around;\n}\n\n.MuiTypography-root.channelName {\n    font-size: 20px;\n    font-weight: 400;\n    color: #fff;\n    font-family: var(--font-family-primary);\n}\n\n.MuiBox-root.channelBox {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.youtubeHeaderIcon {\n    display: flex;\n    align-items: flex-start;\n    flex-direction: column;\n}\n\n.IconHeader {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.MuiBox-root.toggleContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.MuiBox-root.width44 {\n    width: 100%;\n}\n\n.MuiBox-root.youtubeCategory {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n.MuiFormLabel-asterisk {\n    color: #FF0000;\n}\n\n.MuiAutocomplete-endAdornment {\n    display: none;\n}\n\n.MuiBox-root.buttonEnds {\n    display: flex;\n    gap: 10px;\n}\n/* tabs section */\n.MuiBox-root.ytubeTabSection{\n    margin-bottom: 20px;\n}\n.MuiTabs-root.ytubeTabs .MuiTabs-scroller .MuiTabs-flexContainer {\n    border-bottom: 1px solid #4F5384;\n}\n.MuiButtonBase-root.ytubeTab{\n    text-transform: none;\n    font-size: 16px;\n    font-weight: 500;\n    color: #B3B0C1;\n    font-family: var(--font-family-primary);\n    min-width: auto;\n    padding: 0px;\n    margin-right: 20px;\n}\n.MuiButtonBase-root.ytubeTab.Mui-selected{\n    color: #fff;\n    border-bottom: 2px solid #fff;\n}\n.MuiTabs-indicator{\n    background: #fff !important;\n}\n.MuiFormLabel-root.formlabel{\nfont-family: var(--font-family-primary);\ncolor: #fff;\nfont-size: 16px;\nfont-weight: 400;\n}\n\n@media screen and (min-width: 768px) {\n    .MuiBox-root.youtubePublish {\n        display: flex;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .MuiBox-root.videoConntector {\n        display: flex;\n        align-items: flex-start;\n        gap: 20px;\n        flex-direction: column;\n    }\n\n    .MuiBox-root.buttonEnd {\n        display: flex;\n        justify-content: flex-end;\n        padding: 0px 20px;\n    }\n\n    .MuiBox-root.buttonEnds {\n        display: flex;\n        justify-content: flex-end;\n        gap: 10px;\n    }\n\n    .MuiBox-root.width44 {\n        width: 44%;\n    }\n\n    .MuiBox-root.youtubeConnector {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        flex-direction: row;\n        justify-content: space-between;\n    }\n}\n\n@media screen and (min-width: 1024px) {\n    .MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {\n        max-width: 80%;\n    }\n\n}\n\n@media screen and (min-width: 1440px) {\n    .MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {\n        max-width: 60%;\n    }\n\n}\n\n@media screen and (min-width: 1920px) {\n    .MuiDialog-root.youtubeContainer .MuiDialog-container .MuiPaper-root {\n        max-width: 50%;\n    }\n\n}\n\n\n/* date picker */\n\n.MuiBox-root.dateCategory{\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n}\n.MuiFormLabel-root{\n    color: #fff\n}\n.MuiButtonBase-root.MuiPickersDay-root{\nbackground-color: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
